export const RightItemsName = 'rightItemsComponent';

export const QRCodeBtnName = 'qrCodeBtn';
